import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import * as SX from './sx';
import type { EmployeeByDepartmentItemFilterInputErrorProps as Props } from './types';

export const EmployeeByDepartmentItemFilterInputError = memo(
  ({ className, show, field, value }: Props) => {
    const message = useMemo(() => {
      if (field === 'employee_by_department_department') {
        if (!value) return 'The job role or department has not been chosen.';
      }
      if (field === 'employee_by_department_number') {
        if (!value) return 'Range not included.';
      }
      if (field === 'headcount_growth_department') {
        if (!value) return 'The job role or department has not been chosen.';
      }
      if (field === 'headcount_growth_number') {
        if (!value) return 'Employee Growth range not included.';
      }
    }, [field, value]);

    const paddingBottom = useMemo(() => {
      if (
        field === 'employee_by_department_number' ||
        field === 'headcount_growth_number'
      ) {
        return 1;
      }
      return 0;
    }, [field]);

    if (!show) return null;

    return (
      <Box
        display="flex"
        alignItems="center"
        paddingLeft={1}
        paddingBottom={paddingBottom}
      >
        <Typography
          className={classnames(
            'EmployeeByDepartmentItemFilterInputError',
            className
          )}
          sx={SX.root}
          variant="body5"
          color="error"
        >
          {message}
        </Typography>
      </Box>
    );
  }
);

EmployeeByDepartmentItemFilterInputError.displayName =
  'EmployeeByDepartmentItemFilterInputError';
